import React from 'react';
import { Image } from '../../../../../../wag-react/next-components/image';
import { SocialShareUrls } from '../../../../../../constants';
import pinterestSocialIcon from '../../../../../../assets/icons/pinterest_social_icon@2x.png';
import { Button } from '../../../../../../wag-react/next-components/button';
export const PinterestShareButton = ({
  shareUrl
}) => <Button data-sentry-element="Button" data-sentry-component="PinterestShareButton" data-sentry-source-file="index.tsx">
    {/* // Pinterest sdk will not error if using jsx components as the link */}
    <a href={SocialShareUrls.PinterestButtonUrl} data-pin-do="buttonPin" data-pin-custom="true" data-pin-url={shareUrl}>
      <Image width="36px" height="36px" alt="pinterest-share-icon" src={pinterestSocialIcon} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
    </a>
  </Button>;